import {RulesNamespaceTypesEnum} from '../../models/api/ruleModel';
import {RuleActionTypesEnum} from './ruleActionModel';
import {RuleConditionTypesEnum} from './ruleConditionModel';
import {RuleTriggerEventTypes} from './ruleTriggerModel';

interface AccountRules {
  [RulesNamespaceTypesEnum.EVENTS]: ReadonlyArray<RuleTriggerEventTypes>;
  [RulesNamespaceTypesEnum.ACTIONS]: ReadonlyArray<RuleActionTypesEnum>;
  [RulesNamespaceTypesEnum.COMPOUND_CONDITIONS]: ReadonlyArray<RuleConditionTypesEnum>;
}

export const accountRules: AccountRules = {
  [RulesNamespaceTypesEnum.EVENTS]: [],
  [RulesNamespaceTypesEnum.ACTIONS]: [
    RuleActionTypesEnum.ASSIGN_ACCOUNT_FIELD,
    RuleActionTypesEnum.NOTIFY_ACCOUNT_FIELD,
  ],
  [RulesNamespaceTypesEnum.COMPOUND_CONDITIONS]: [
    RuleConditionTypesEnum.ACCOUNT_CUSTOM_ATTRIBUTE_BOOLEAN,
    RuleConditionTypesEnum.ACCOUNT_CUSTOM_ATTRIBUTE_DATETIME,
    RuleConditionTypesEnum.ACCOUNT_CUSTOM_ATTRIBUTE_NUMBER,
    RuleConditionTypesEnum.ACCOUNT_CUSTOM_ATTRIBUTE_STRING,
    RuleConditionTypesEnum.ACCOUNT_CUSTOM_ATTRIBUTE_TEAMMATE,
  ],
};
